import React, { useEffect, useState } from "react";

import { Container, Nav, Navbar, Button, Image, Spinner } from "react-bootstrap";

import { 

  BrowserRouter as Router, 

  Routes, 

  Route, 

  Link, 

  useLocation, 

  Navigate 

} from "react-router-dom";


// Import components

import Home from "./components/Home";

import ImageAnalysis from "./components/ImageAnalysis";

import VideoAnalysis from "./components/VideoAnalysis";

import FaceComparison from "./components/FaceComparison";

import FaceCollectionSearch from "./components/FaceCollectionSearch";

import Callback from "./components/Callback";

import ApiKeyManagement from "./components/ApiKeyManagement";


// Import auth functions

import { login, logout, isAuthenticated } from "./services/authService";

import { checkAdminAccess } from "./services/adminApiService";


// Import styles

import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";


/** Navigation Bar */

const NavigationBar = ({ authenticated, isAdmin = false }) => (

  <Navbar bg="dark" variant="dark" expand="lg">

    <Container>

      <Navbar.Brand as={Link} to="/">

        <Image 

          src="https://redbeardpi.com/images/black-logo.png" 

          alt="FaceAI Logo"

          className="logo-img"

          style={{ height: "40px", width: "auto" }} 

        />

      </Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />

      <Navbar.Collapse id="basic-navbar-nav">

        <Nav className="me-auto">

          {authenticated && (

            <>

              <Nav.Link as={Link} to="/">Home</Nav.Link>

              <Nav.Link as={Link} to="/image-analysis">Image Analysis</Nav.Link>

              <Nav.Link as={Link} to="/face-comparison">Face Comparison</Nav.Link>

              <Nav.Link as={Link} to="/face-collection-search">Face Search</Nav.Link>

              {isAdmin && <Nav.Link as={Link} to="/api-keys">API Keys</Nav.Link>}

              <Nav.Link as={Link} to="/video-analysis"> </Nav.Link>

            </>

          )}

        </Nav>

        <Nav>

          {authenticated ? (

            <Button variant="outline-light" onClick={logout}>Logout</Button>

          ) : (

            <Button variant="outline-light" onClick={login}>Login</Button>

          )}

        </Nav>

      </Navbar.Collapse>

    </Container>

  </Navbar>

);


/** Main Application Component */

function App() {

  return (

    <Router>

      <MainContent />

    </Router>

  );

}


/** Authentication & Routing */

const MainContent = () => {

  const location = useLocation();

  const [authenticated, setAuthenticated] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [isAdmin, setIsAdmin] = useState(false);

  const [adminCheckComplete, setAdminCheckComplete] = useState(false);

  

  // Check authentication status when component mounts

  useEffect(() => {

    const checkAuthStatus = () => {

      console.log("Checking authentication status on page load");

      const authStatus = isAuthenticated();

      setAuthenticated(authStatus);

      setIsLoading(false);

      

      // Store current path for redirect after login if needed

      if (!authStatus && location.pathname !== '/auth/callback') {

        localStorage.setItem('auth_redirect_path', location.pathname);

      }

    };

    

    checkAuthStatus();

  }, [location.pathname]);

  useEffect(() => {

    let cancelled = false;

    if (!authenticated) {

      setIsAdmin(false);

      setAdminCheckComplete(true);

      return () => {

        cancelled = true;

      };

    }

    setAdminCheckComplete(false);

    checkAdminAccess()

      .then(hasAccess => {

        if (!cancelled) setIsAdmin(hasAccess);

      })

      .catch(() => {

        if (!cancelled) setIsAdmin(false);

      })

      .finally(() => {

        if (!cancelled) setAdminCheckComplete(true);

      });

    return () => {

      cancelled = true;

    };

  }, [authenticated]);

  

  // Listen for auth state changes from the Callback component

  const handleAuthSuccess = () => {

    console.log("Auth success received from Callback component");

    setAuthenticated(true);

  };

  

  // Show loading indicator while checking auth

  if (isLoading) {

    return (

      <div className="App">

        <NavigationBar authenticated={false} />

        <Container className="mt-4 mb-5 text-center">

          <Spinner animation="border" role="status" />

          <p>Loading application...</p>

        </Container>

      </div>

    );

  }

  

  return (

    <div className="App">

      <NavigationBar authenticated={authenticated} isAdmin={isAdmin} />

      <Container className="mt-4 mb-5">

        <Routes>

          {/* Auth callback route - accessible even when not authenticated */}

          <Route path="/auth/callback" element={<Callback onAuthSuccess={handleAuthSuccess} />} />

          

          {authenticated ? (

            <>

              <Route path="/" element={<Home />} />

              <Route path="/image-analysis" element={<ImageAnalysis />} />

              <Route path="/video-analysis" element={<VideoAnalysis />} />

              <Route path="/face-comparison" element={<FaceComparison />} />

              <Route path="/face-collection-search" element={<FaceCollectionSearch />} />

              <Route path="/api-keys" element={

                adminCheckComplete ? (

                  isAdmin ? <ApiKeyManagement /> : <Navigate to="/" replace />

                ) : (

                  <div className="text-center py-5">

                    <Spinner animation="border" role="status" />

                    <p className="mt-3">Checking administrator access…</p>

                  </div>

                )

              } />

              <Route path="*" element={<Navigate to="/" replace />} />

            </>

          ) : (

            <Route path="*" element={

              <div className="text-center mt-5">

                <h2>Welcome</h2>

                <p>Please log in to access the application</p>

                <Button variant="primary" onClick={login}>Login</Button>

              </div>

            } />

          )}

        </Routes>

      </Container>

    </div>

  );

};


export default App;
